import StaticHtmlComponent from "../components/StaticHtmlComponent"

export default function StaticTestPage() {
    return (
        <StaticHtmlComponent/>
    )
}